export const ru = {
  media: {
    library: {
      title: 'Медиатека',
      subtitle: 'Фото и видео блога. Превью делаются сами, а фото, которые соцсети как есть не принимают (HEIC, WebP, JPEG XL и другие), получают ещё JPEG-копию.',
      upload: 'Загрузить файлы',
      uploadHint: 'Перетащите фото и видео сюда или нажмите, чтобы выбрать',
      search: 'Поиск по имени и заметке',
      kind: 'Вид',
      kinds: { all: 'Все', image: 'Фото', video: 'Видео' },
      unattached: 'Только не прикреплённые',
      empty: 'Медиатека пустая',
      emptyText: 'Загрузите фото и видео после похода в заведение.',
      emptySearch: 'Ничего не найдено',
      usedIn: { one: 'в {n} посте', few: 'в {n} постах', many: 'в {n} постах', other: 'в {n} поста' },
      noPreview: 'без превью',
    },
    uploads: {
      title: 'Загрузка',
      uploading: 'Загружается…',
      done: 'Готово',
      duplicate: 'Уже было в медиатеке',
      failed: 'Ошибка',
      progress: 'Прогресс загрузки {name}',
      clear: 'Очистить список',
    },
    card: {
      title: 'Медиа',
      back: '← Медиатека',
      backToPost: '← Вернуться к посту «{title}»',
      backToPostUntitled: '← Вернуться к посту',
      originalName: 'Файл',
      type: 'Тип',
      size: 'Размер',
      dimensions: 'Разрешение',
      duration: 'Длительность',
      seconds: '{n} с',
      takenAt: 'Снято',
      uploadedAt: 'Загружено',
      rendition: 'JPEG-копия',
      renditionYes: 'есть — используется при публикации',
      stored: 'Занимает',
      storedWithPreview: '{size} вместе с превью',
      storedWithCopy: '{size} вместе с превью и JPEG-копией',
      recompressed: 'Пережато',
      recompressedValue: 'из {ext}, {size}, {at}',
      note: 'Заметка',
      notePlaceholder: 'Например: интерьер, второй этаж',
      saveNote: 'Сохранить заметку',
      posts: 'Используется в постах',
      notUsed: 'Не прикреплено ни к одному посту.',
      downloadOriginal: 'Скачать оригинал',
      deleteConfirm: 'Удалить файл «{name}»?',
      blockedBy: 'Медиа прикреплено к постам:',
    },
    picker: {
      title: 'Выбор медиа',
      selected: { one: 'Выбрано: {n}', few: 'Выбрано: {n}', many: 'Выбрано: {n}', other: 'Выбрано: {n}' },
      attach: 'Прикрепить',
      inPost: 'уже в посте',
    },
    storage: {
      title: 'Хранилище медиа',
      intro: 'Сколько места занимают медиа блога вместе с JPEG-копиями и превью. Это место считается в лимит «Объём медиа» тарифа.',
      total: 'Всего: {size}',
      files: { one: '{n} файл', few: '{n} файла', many: '{n} файлов', other: '{n} файла' },
      byFormat: 'По форматам',
      format: 'Формат',
      count: 'Файлов',
      bytes: 'Объём',
      unmeasured: { one: 'У {n} медиа объём превью и копии ещё замеряется — итог уточнится.', few: 'У {n} медиа объём превью и копий ещё замеряется — итог уточнится.', many: 'У {n} медиа объём превью и копий ещё замеряется — итог уточнится.', other: 'У {n} медиа объём превью и копий ещё замеряется — итог уточнится.' },
      empty: 'В медиатеке пока нет файлов',
      emptyText: 'Здесь будет видно, сколько места занимают фото и видео блога.',
      recompress: 'Пережать исходники…',
      recompressHint: 'Тяжёлые оригиналы (HEIC, MOV в 4K) можно заменить сжатыми файлами, чтобы освободить место.',
      unavailable: 'Пережатие недоступно: на сервере нет обработчика медиа (ffmpeg). Обратитесь к администратору.',
      busy: 'В блоге идёт фоновая задача — новую можно поставить, когда она завершится.',
      busyLink: 'Открыть задачу',
    },
    recompress: {
      title: 'Пережать исходники',
      intro: 'Оригиналы выбранных форматов заменяются сжатыми файлами. Медиа остаются в своих постах с порядком и заметками, метаданные снимка (дата, камера, геометка, цветовой профиль) сохраняются.',
      sources: 'Какие форматы пережать',
      source: '{ext} — {files}, {size}',
      noSources: 'Отметьте хотя бы один формат.',
      imageTarget: 'Фото — в формат',
      videoTarget: 'Видео — в формат',
      targets: { jpeg: 'JPEG', webp: 'WebP', jxl: 'JPEG XL', h264: 'MP4 (H.264)' },
      preset: 'Параметры',
      presets: { economy: 'Экономно', balanced: 'Сбалансированно', quality: 'Качество', custom: 'Свои' },
      presetHints: {
        economy: 'Под публикацию: фото до 2560 px, видео 720p и 30 кадров/с. Больше всего места.',
        balanced: 'Фото до 4096 px, видео 1080p. Разницу с оригиналом почти не видно.',
        quality: 'Размер кадра как у оригинала, сжатие мягкое. Места освобождается меньше.',
        custom: 'Задайте параметры сами.',
      },
      quality: 'Качество фото',
      qualityHint: '1–100: больше — лучше и тяжелее',
      maxLongSide: 'Длинная сторона фото, не больше',
      crf: 'Качество видео (CRF)',
      crfHint: '16–35: меньше — лучше и тяжелее',
      maxShortSide: 'Короткая сторона кадра видео, не больше',
      maxFps: 'Частота кадров, не больше',
      audioKbps: 'Звук',
      minSavings: 'Наименьшая выгода, %',
      minSavingsHint: 'Файл пережимается, только если вместе с копией и превью станет меньше хотя бы на столько',
      noResize: 'Без уменьшения',
      sameFps: 'Как у исходника',
      px: '{n} px',
      fps: '{n} кадров/с',
      kbps: '{n} кбит/с',
      summary: 'Будет пережато: {files}, {size}.',
      submit: 'Пережать',
      confirmTitle: 'Пережать {files} ({size})?',
      confirmText: 'Оригиналы будут заменены, вернуть их нельзя — при необходимости сначала сделайте резервную копию. Работа пойдёт в фоне, её ход виден в индикаторе фоновых задач.',
      confirm: 'Пережать',
      started: 'Пережатие поставлено в очередь: ход — в индикаторе фоновых задач.',
      paramsTitle: 'Параметры',
      resultTitle: 'Итог',
      params: {
        image: 'Фото → {target}, качество {quality}, {size}',
        video: 'Видео → {target}, CRF {crf}, {size}, {fps}, звук {kbps}',
        sources: 'Форматы: {list}',
        minSavings: 'Наименьшая выгода: {n}%',
      },
      report: {
        converted: 'Пережато: {n}',
        notWorth: 'Невыгодно, оставлено как было: {n}',
        failed: 'Не удалось: {n}',
        skipped: 'Пропущено (удалено или изменено во время задачи): {n}',
        volume: 'Было {before} → стало {after}',
        saved: 'Освобождено {size} ({percent}%)',
        failures: 'Не удалось пережать',
        file: 'Файл',
        reason: 'Причина',
        demo: 'Демо-режим: пережатие имитировалось, файлы не менялись.',
      },
    },
    recount: {
      measured: 'Замерено медиа: {n}',
      missing: 'Файлов нет в хранилище: {n}',
    },
    traffic: {
      title: 'Трафик медиа',
      intro: 'Файлы блога отдаются только через систему: здесь видно, сколько данных скачали участники за месяц и по дням.',
      month: 'Отдано за {month}',
      limit: '{used} из {limit}',
      noLimit: '{used}, без лимита',
      limitReached: 'Лимит исчерпан: оригиналы, JPEG-копии и архивы пакетов снова будут доступны в следующем месяце. Превью показываются.',
      byKind: 'По видам файлов за месяц',
      byDay: 'По дням, последние 30 дней',
      empty: 'За последние 30 дней файлы не скачивали.',
      kind: 'Вид',
      day: 'День',
      requests: 'Запросы',
      bytes: 'Отдано',
      browserCache: 'Из кеша браузера',
      serverCache: 'Из кеша сервера',
      kinds: { original: 'Оригиналы', thumbnail: 'Превью', rendition: 'JPEG-копии', archive: 'Архивы пакетов' },
    },
  },
};

export const en: typeof ru = {
  media: {
    library: {
      title: 'Media library',
      subtitle: 'Blog photos and videos. Previews are made automatically, and photos social networks don\'t accept as is (HEIC, WebP, JPEG XL and others) also get a JPEG copy.',
      upload: 'Upload files',
      uploadHint: 'Drop photos and videos here or click to choose',
      search: 'Search by name and note',
      kind: 'Kind',
      kinds: { all: 'All', image: 'Photos', video: 'Videos' },
      unattached: 'Only unattached',
      empty: 'The media library is empty',
      emptyText: 'Upload photos and videos after visiting a place.',
      emptySearch: 'Nothing found',
      usedIn: { one: 'in {n} post', few: 'in {n} posts', many: 'in {n} posts', other: 'in {n} posts' },
      noPreview: 'no preview',
    },
    uploads: {
      title: 'Uploads',
      uploading: 'Uploading…',
      done: 'Done',
      duplicate: 'Already in the library',
      failed: 'Failed',
      progress: 'Upload progress for {name}',
      clear: 'Clear list',
    },
    card: {
      title: 'Media',
      back: '← Media library',
      backToPost: '← Back to post “{title}”',
      backToPostUntitled: '← Back to post',
      originalName: 'File',
      type: 'Type',
      size: 'Size',
      dimensions: 'Resolution',
      duration: 'Duration',
      seconds: '{n} s',
      takenAt: 'Taken',
      uploadedAt: 'Uploaded',
      rendition: 'JPEG copy',
      renditionYes: 'available — used for publishing',
      stored: 'Takes',
      storedWithPreview: '{size} with the preview',
      storedWithCopy: '{size} with the preview and JPEG copy',
      recompressed: 'Recompressed',
      recompressedValue: 'from {ext}, {size}, {at}',
      note: 'Note',
      notePlaceholder: 'E.g. interior, second floor',
      saveNote: 'Save note',
      posts: 'Used in posts',
      notUsed: 'Not attached to any post.',
      downloadOriginal: 'Download original',
      deleteConfirm: 'Delete file “{name}”?',
      blockedBy: 'The media is attached to posts:',
    },
    picker: {
      title: 'Choose media',
      selected: { one: '{n} selected', few: '{n} selected', many: '{n} selected', other: '{n} selected' },
      attach: 'Attach',
      inPost: 'already in post',
    },
    storage: {
      title: 'Media storage',
      intro: 'How much space the blog\'s media take together with JPEG copies and previews. This space counts towards the plan\'s media volume limit.',
      total: 'Total: {size}',
      files: { one: '{n} file', few: '{n} files', many: '{n} files', other: '{n} files' },
      byFormat: 'By format',
      format: 'Format',
      count: 'Files',
      bytes: 'Volume',
      unmeasured: { one: 'The preview and copy size of {n} media is still being measured — the total will be refined.', few: 'The preview and copy sizes of {n} media are still being measured — the total will be refined.', many: 'The preview and copy sizes of {n} media are still being measured — the total will be refined.', other: 'The preview and copy sizes of {n} media are still being measured — the total will be refined.' },
      empty: 'The media library has no files yet',
      emptyText: 'This will show how much space the blog\'s photos and videos take.',
      recompress: 'Recompress sources…',
      recompressHint: 'Heavy originals (HEIC, 4K MOV) can be replaced with compressed files to free up space.',
      unavailable: 'Recompression is unavailable: the server has no media processor (ffmpeg). Contact the administrator.',
      busy: 'A background task is running in the blog — a new one can be started when it finishes.',
      busyLink: 'Open the task',
    },
    recompress: {
      title: 'Recompress sources',
      intro: 'Originals of the selected formats are replaced with compressed files. Media stay in their posts with order and notes; the photo metadata (date, camera, location, color profile) is kept.',
      sources: 'Formats to recompress',
      source: '{ext} — {files}, {size}',
      noSources: 'Select at least one format.',
      imageTarget: 'Photos — to format',
      videoTarget: 'Videos — to format',
      targets: { jpeg: 'JPEG', webp: 'WebP', jxl: 'JPEG XL', h264: 'MP4 (H.264)' },
      preset: 'Settings',
      presets: { economy: 'Economy', balanced: 'Balanced', quality: 'Quality', custom: 'Custom' },
      presetHints: {
        economy: 'For publishing: photos up to 2560 px, video 720p at 30 fps. Frees the most space.',
        balanced: 'Photos up to 4096 px, video 1080p. Hardly distinguishable from the original.',
        quality: 'Frame size as in the original, gentle compression. Frees less space.',
        custom: 'Set the parameters yourself.',
      },
      quality: 'Photo quality',
      qualityHint: '1–100: higher is better and heavier',
      maxLongSide: 'Photo long side, at most',
      crf: 'Video quality (CRF)',
      crfHint: '16–35: lower is better and heavier',
      maxShortSide: 'Video frame short side, at most',
      maxFps: 'Frame rate, at most',
      audioKbps: 'Audio',
      minSavings: 'Minimum saving, %',
      minSavingsHint: 'A file is recompressed only if, with its copy and preview, it gets at least this much smaller',
      noResize: 'No downscaling',
      sameFps: 'As in the source',
      px: '{n} px',
      fps: '{n} fps',
      kbps: '{n} kbit/s',
      summary: 'To recompress: {files}, {size}.',
      submit: 'Recompress',
      confirmTitle: 'Recompress {files} ({size})?',
      confirmText: 'The originals will be replaced and cannot be restored — make a backup first if needed. The work runs in the background; its progress is shown in the background tasks indicator.',
      confirm: 'Recompress',
      started: 'Recompression is queued: see the background tasks indicator for progress.',
      paramsTitle: 'Parameters',
      resultTitle: 'Result',
      params: {
        image: 'Photos → {target}, quality {quality}, {size}',
        video: 'Videos → {target}, CRF {crf}, {size}, {fps}, audio {kbps}',
        sources: 'Formats: {list}',
        minSavings: 'Minimum saving: {n}%',
      },
      report: {
        converted: 'Recompressed: {n}',
        notWorth: 'Not worth it, kept as is: {n}',
        failed: 'Failed: {n}',
        skipped: 'Skipped (deleted or changed during the task): {n}',
        volume: 'Was {before} → now {after}',
        saved: 'Freed {size} ({percent}%)',
        failures: 'Could not recompress',
        file: 'File',
        reason: 'Reason',
        demo: 'Demo mode: recompression was simulated, files were not changed.',
      },
    },
    recount: {
      measured: 'Media measured: {n}',
      missing: 'Files missing from the storage: {n}',
    },
    traffic: {
      title: 'Media traffic',
      intro: 'Blog files are served only through the system: here is how much data members downloaded this month and per day.',
      month: 'Served in {month}',
      limit: '{used} of {limit}',
      noLimit: '{used}, no limit',
      limitReached: 'The limit is used up: originals, JPEG copies and package archives become available again next month. Thumbnails are still shown.',
      byKind: 'By file kind this month',
      byDay: 'By day, last 30 days',
      empty: 'No files were downloaded in the last 30 days.',
      kind: 'Kind',
      day: 'Day',
      requests: 'Requests',
      bytes: 'Served',
      browserCache: 'From browser cache',
      serverCache: 'From server cache',
      kinds: { original: 'Originals', thumbnail: 'Thumbnails', rendition: 'JPEG copies', archive: 'Package archives' },
    },
  },
};
